import { useLocation } from 'react-router'

/** Rotas do fluxo WhatsApp (header/footer reduzidos). Não usar substring genérica: slugs como "getaway" contêm "wa". */
export const WHATSAPP_CHECKOUT_PATHNAMES = new Set([
  '/analise-cannect-wa',
  '/analise-cannect-wa2',
  '/carrinho-wa',
  '/carrinho-wa2',
  '/carrinho-wa-novo',
  '/documentos-wa',
  '/documentos-wa2',
  '/validate-documentos-wa'
])

export const isWhatsAppCheckoutPath = (pathname: string) =>
  WHATSAPP_CHECKOUT_PATHNAMES.has(pathname) || pathname.startsWith('/finalizar-compra-wa/')

export const usePublicRender = () => {
  const { pathname } = useLocation()
  // /carrinho-wa usa o layout do /carrinho (header completo). Continua público
  // para 401 (isWhatsAppCheckoutPath), só o chrome reduzido que não vale aqui.
  const isPublic = isWhatsAppCheckoutPath(pathname) && pathname !== '/carrinho-wa'
  const isHigherThanMd = window.innerWidth > 768
  const isLowerEqualMd = window.innerWidth <= 768

  return {
    isPublic,
    isHigherThanMd,
    isLowerEqualMd
  }
}
